import createLogger from 'driftwood'
const logger = createLogger('ptv')
logger.enable()
export default logger
